import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

export interface LoadingState {
  count: number;
}

const initialState: LoadingState = { count: 0 };

export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.count += 1;
    },
    stopLoading: (state) => {
      state.count = Math.max(0, state.count - 1);
    }
  }
});

export const { startLoading, stopLoading } = loadingSlice.actions;
export const isGlobalLoading = (state: RootState) => state.loading.count > 0;

export default loadingSlice.reducer;





